import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useContext, useEffect, useState } from "react";
import { MainContext } from "../context/OpenInvoice";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import PaymentIcon from "@mui/icons-material/Payment";
import Payment from "./Payment";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import { Link } from "react-router-dom";
import { blue } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

function Totalsum({ heightDisplay, alertValue, heightScreen }) {
  const [state, dispatch] = useContext(MainContext);
  const [clicked, setClicked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [pelecradUrl, setPelecardUrl] = useState();
  const navigate = useNavigate();

  const totalSum = state.reduce((acc, item) => {
    if (item.checked) {
      return parseFloat((acc + item.IVBALANCE).toFixed(2));
    }
    return acc;
  }, 0);

  // const totalSum = 10;
  useEffect(() => {
    alertValue(totalSum);
  }, [totalSum]);

  const handleChange = async () => {
    setTimeout(() => setClicked(true), 300);
    const checkedItems = state.filter((item) => item.checked);
    try {
      const response = await axios.post(`/payments/display_pelecard_iframe`, {
        total: totalSum,
        NEO_PAYMENTBYIVLOG: checkedItems,
        withCredentials: true,
      });
      setPelecardUrl(response.data);
    } catch (error) {
      if (error.response.status == 403) {
        navigate("/");
      }
    }
  };

  const collapseValue = (value) => {
    setIsOpen(value);
  };

  const closeHandel = () => {
    setClicked(false);
  };

  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          display: { xs: "block", md: "none" },
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            width: heightDisplay > 899 ? "59%" : "83%",
            marginTop: "1rem",
            marginBottom: "4.4rem",
            padding: "1rem",
            borderRadius: "16px",
            bgcolor: "white",
            transform: "translateX(-50%)",
            left: "50%",
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Typography variant="h6">
              תשלום: 
              <span>
                {totalSum < 0
                  ? ` ${parseFloat(Math.abs(totalSum)).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}- `
                  : ` ${parseFloat(totalSum).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                ₪
              </span>
            </Typography>
            {isOpen ? (
              <Button
                variant="contained"
                endIcon={<PaymentIcon />}
                disabled={totalSum > 0 ? false : true}
                onClick={handleChange}
                alt="paymentButton"
              >
                תשלום
              </Button>
            ) : (
              <IconButton
                onClick={closeHandel}
                color="primary"
                aria-label="close button"
                component="label"
              >
                <CloseIcon alt="closeButton" />
              </IconButton>
            )}
          </Stack>
          <Payment
            payment={totalSum > 0 ? clicked : false}
            collapseValue={collapseValue}
            heightDisplay={heightDisplay}
            pelecradUrl={pelecradUrl}
          />
        </Box>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: { xs: "none", md: "block" },
          backgroundColor: "rgb(219, 217, 217)",
          padding: "1rem",
          borderRadius: "16px",
          marginTop: "1rem",
        }}
      >
        <Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Typography variant="h6">
              תשלום:
              <span>
                {totalSum < 0
                  ? ` ${parseFloat(Math.abs(totalSum)).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}- `
                  : ` ${parseFloat(totalSum).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                ₪
              </span>
            </Typography>
            {isOpen ? (
              <Button
                variant="contained"
                endIcon={<PaymentIcon />}
                disabled={totalSum > 0 ? false : true}
                onClick={handleChange}
                alt="paymentButton"
              >
                תשלום
              </Button>
            ) : (
              <IconButton
                onClick={closeHandel}
                color="primary"
                aria-label="close button"
                component="label"
              >
                <CloseIcon alt="closeButton" />
              </IconButton>
            )}
          </Stack>
          <Payment
            payment={totalSum > 0 ? clicked : false}
            collapseValue={collapseValue}
            heightDisplay={heightDisplay}
            pelecradUrl={pelecradUrl}
          />
        </Box>
      </Box>
    </>
  );
}

export default Totalsum;
